// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u6IY","type":"styles_type__1Rnyr","choices":"styles_choices__uLI7_"};